import 'core-js/features/promise'

export default () => {
  return new Promise ((resolve) => {
    if (
      !('IntersectionObserver' in window) ||
      !('IntersectionObserverEntry' in window) ||
      !('intersectionRatio' in window.IntersectionObserverEntry.prototype)
    ) {
      return import(/* webpackChunkName: "intersection-observer-polyfill" */ 'intersection-observer').then(resolve)     
    }

    return resolve()
  })
}